module.exports = __webpack_public_path__ + "static/media/PublicSans-Bold.d914660e.woff2";